module.exports = __webpack_public_path__ + "img/wojciech-jurgowiak.2155cab8.png";